<template>
    <div
        class="tw-bg-infinity-highlight-faded tw-flex tw-items-center tw-space-x-3 tw-p-3 tw-rounded tw-text-infinity-primary-text">
        <font-awesome-icon class="tw-text-infinity-highlight" :icon="['far', 'info-circle']" />
        <div>
            Please contact {{ producerName }} via his email <strong>{{ producerEmail }}</strong>
            quoting your order number <strong>{{ orderNumber }}</strong> if you have any questions.
        </div>
    </div>
</template>
<script>
export default {
    mounted() {
        this.producerEmail = ab.order.sellerEmail;
        this.producerName = ab.user?.name;
        this.orderNumber = ab.order.number;
    },
    data() {
        return {
            producerEmail: '',
            producerName: '',
            orderNumber: ''
        };
    }
};
</script>
